@if (data && data.length > 0) {

   <table class="table table-hover table-sm table-striped mb-0" id="info-table" data-testid="grid-table" [ngClass]="schema.clickableRows ? 'clickable-table' : ''">
      <thead>
         @if (schema) {
         <tr>
            @if (selectable) {
            <th>
               @if (selectable === 'multiple') {
                  <input data-testid="grid-checkbox-selectAll" type="checkbox" name="selectAll" [value]="allSelected" (change)="selectAll()" />
               }
            </th>
            }
            @for (item of schema.schema; track item) {
            <th scope="col" [ngClass]="item.customClass || ''">
               <span>{{item.title | translate }} &nbsp;</span>
               @if (item.sortable && item.field !== sorting?.sortBy) {
               <fa-icon data-testid="grid-icon-sort" class="cursor-pointer" [icon]="['fas', 'sort']" (click)="changeSorting(item.field, SortDirection.Ascending)"
                 >
               </fa-icon>
               }
               @if (item.sortable && item.field === sorting?.sortBy && sorting?.sortDirection === SortDirection.Ascending) {
               <fa-icon data-testid="grid-icon-sortAsc" class="cursor-pointer" [icon]="['fas', 'sort-amount-up']" (click)="changeSorting(item.field, SortDirection.Descending)"
                 >
               </fa-icon>
               }
               @if (item.sortable && item.field === sorting?.sortBy && sorting?.sortDirection === SortDirection.Descending) {
               <fa-icon data-testid="grid-icon-sortDesc" class="cursor-pointer" [icon]="['fas', 'sort-amount-down']" (click)="changeSorting(item.field, SortDirection.Ascending)"
                 >
               </fa-icon>
               }
            </th>
            }
         </tr>
         }
      </thead>
      @if (data) {
      <tbody>
         @for (rowData of data; track rowData; let i = $index) {
         <tr [attr.data-testid]="'grid-row-' + i">
            @if (!rowTemplateRef) {

               @if (selectable) {
               <td>
                  <input [attr.data-testid]="'grid-checkbox-row-' + i" type="checkbox" name="selectSingle" [value]="selectedRows?.includes(rowData)" (change)="changeSelection(rowData)" />
               </td>
               }
               @for (schemaItem of schema.schema; track schemaItem) {
               <td scope="row" (click)="onRowClicked(rowData, schemaItem.field)"
                  [ngClass]="[schemaItem.customClass || '', (schemaItem.field | columnTemplateRef: columnTemplateMap) ? 'template-cell' : 'normal-cell']">
                  @if (!(schemaItem.field | columnTemplateRef: columnTemplateMap)) {

                     @if (schemaItem.type !== 'boolean' && !schemaItem.converter) {
                     <span>
                        <span>{{rowData | rowData: schemaItem}}</span>
                     </span>
                     }
                     @if (schemaItem.type === 'boolean') {
                     <span>
                        @if (rowData | rowData: schemaItem) {
                        <span>
                           <i class="fad fa-check-square ml-2"></i>
                        </span>
                        }
                     </span>
                     }
                     @if (schemaItem.converter) {
                     <span>
                        <span>{{schemaItem.converter!(rowData | rowData: schemaItem)}}</span>
                     </span>
                     }
                  
                  }
                  @if (schemaItem.field | columnTemplateRef: columnTemplateMap) {
                  <ng-template [ngTemplateOutlet]="schemaItem.field | columnTemplateRef: columnTemplateMap"
                     [ngTemplateOutletContext]="{value: rowData | rowData: schemaItem, row: rowData, column: schemaItem.field, index: i}">
                  </ng-template>
                  }
               </td>
               }
            
            }
            @if (rowTemplateRef) {

               <ng-template [ngTemplateOutlet]="rowTemplateRef" [ngTemplateOutletContext]="{value: rowData, row: rowData, index: i}"></ng-template>
            
            }
         </tr>
         }
      </tbody>
      }
   </table>

   @if (data && data.length > 0 && !schema.hideTotal) {
   <nav aria-label="Page navigation example info-color" class="grid-footer">
      <div class="d-flex justify-content-between">
         <div class="d-flex justify-content-start left-content pt-2">
            <span class="refresh-icon pl-1 mr-4">
               <telenet-icon data-testid="grid-icon-refresh" name="redo" (click)="refreshIt()"></telenet-icon>
            </span>
            <span class="refresh-label">
               <span>{{'MC_GRID_TOTAL_COUNT' | translate}}:</span>
               <span class="pl-1" data-testid="grid-value-totalCount">{{paging.totalCount}}</span>
            </span>
            @if (schema.showPageSize) {
            <div class="d-flex ml-5 page-size">
               <label class="page-size-label" for="pageSize">
                  <span>{{'MC_GRID_PAGE_SIZE' | translate}}:</span>
               </label>
               <div class="md-form page-size-input">
                  <my-cloud-page-size data-testid="grid-pagesize-control" [pageSize]="pageSize" (pageSizeChange)="changePageSize($event)" [min]="pageSizeConfig.min || 5" [max]="pageSizeConfig.max || 100">
                  </my-cloud-page-size>
               </div>
            </div>
            }
         </div>
         <div class="left-content d-flex justify-content-end">
            <ul class="pagination d-flex justify-content-end mt-2 ml-5">
               @if (paging.hasPreviousPage) {
               <li class="page-item">
                  <a data-testid="grid-btn-prevPage" class="page-link" (click)="changePage(paging.currentPage - 1)">
                     <span aria-hidden="true">&laquo;</span>
                     <span class="sr-only">Previous</span>
                  </a>
               </li>
               }

               @if (paging.totalPages > 5 && paging.currentPage > 4) {
               <li class="page-item pt-2">
                  <span class="pl-1 pr-1">...</span>
               </li>
               }

               @for (page of pages; track page; let i = $index) {
               <li class="page-item" [ngClass]="{'active': page === paging.currentPage}">
                  <a [attr.data-testid]="'grid-btn-page-' + page" class="page-link" (click)="changePage(page)">{{page}}</a>
               </li>
               }

               @if (paging.totalPages > 5 && paging.currentPage <= (paging.totalPages - 3)) {
               <li class="page-item pt-2">
                  <span class="pl-1 pr-1">...</span>
               </li>
               }

               @if (paging.hasNextPage) {
               <li class="page-item">
                  <a data-testid="grid-btn-nextPage" class="page-link" (click)="changePage(paging.currentPage + 1)">
                     <span aria-hidden="true">&raquo;</span>
                     <span class="sr-only">Next</span>
                  </a>
               </li>
               }
            </ul>
         </div>
      </div>
   </nav>
   }

   @if (data && data.length > 0 && schema.hideTotal) {
   <nav aria-label="Page navigation example info-color" class="grid-footer">
      <ul class="pagination d-flex justify-content-end">
         @if (paging?.hasPreviousPage) {

            <li class="page-item">
               <a data-testid="grid-btn-prevPage" class="page-link" (click)="changePage(paging.currentPage - 1)">
                  <span aria-hidden="true">&laquo;</span>
                  <span class="sr-only">Previous</span>
               </a>
            </li>
            <li class="page-item pt-2">
               <span class="pl-1 pr-1">...</span>
            </li>
         
         }

         <li class="page-item active">
            <a data-testid="grid-btn-currentPage" class="page-link">{{paging?.currentPage}}</a>
         </li>

         @if (paging?.hasNextPage) {

            <li class="page-item pt-2">
               <span class="pl-1 pr-1">...</span>
            </li>
            <li class="page-item">
               <a data-testid="grid-btn-nextPage" class="page-link" (click)="changePage(paging.currentPage + 1)">
                  <span aria-hidden="true">&raquo;</span>
                  <span class="sr-only">Next</span>
               </a>
            </li>
         
         }
      </ul>
   </nav>
   }

} @else {

   <div class="no-result-data" data-testid="grid-message-noData">{{ 'MC_GRID_NO_DATA' | translate}}</div>

}


